import AjaxUrlHtml from '../AjaxUrlHtml/AjaxUrlHtml';

/**
 * @description Get a content from the data-ajax-url attribute,
 * on user click and inject it in the dom.
 */
export default class ActionAjaxUrlHtml extends AjaxUrlHtml {
    /**
     * @description Initialisation of the listeners that will trigger the ajax call.
     */
    init() {
        this.domElementTriggerList = [...document.querySelectorAll(`[data-trigger-target=${this.domElement.dataset.triggerElement}]`)];
        this.injectTplEvent = this.injectTpl.bind(this);

        this.manageListeners(this.domElementTriggerList);
    }

    /**
     * @description Get the template inject it in the dom and remove the listeners.
     */
    injectTpl() {
        const domElementProperties = AjaxUrlHtml.getDOMElementProps(this.domElement);

        AjaxUrlHtml.getTemplate(domElementProperties.url)
            .then(tpl => AjaxUrlHtml.replaceContent(tpl, domElementProperties.dom));

        this.manageListeners(this.domElementTriggerList, 'remove');
    }

    /**
     * @description Add or Remove the listeners to the domItemList.
     * @param {Array} domItemsList - Array of dom Element that will have listeners add or remove.
     * @param {string} [action='add'] - The action on the Listeners.
     */
    manageListeners(domItemsList, action = 'add') {
        domItemsList.forEach(item => {
            item[`${action}EventListener`]('click', this.injectTplEvent);
        });
    }
}
